export { default, getServerSideProps } from '@/views/Campaign/index';
